import { z } from 'zod';

import { ProblemReportIdSchema } from './app_problem_report.js';

/**
 * Sugestões e elogios do "Enviar feedback" do app (voll-specs 2026-10-23-feedback-repo-clickhouse).
 * O support agent (outro repositório) classifica e expõe em `GET /internal/feedback`; o analytics
 * puxa. A lista de temas é espelhada à mão no support agent (`FEEDBACK_THEMES`): mudar aqui e lá.
 */
export const APP_FEEDBACK_THEMES = [
  'voo',
  'hotel',
  'carro',
  'onibus',
  'chat',
  'viagem',
  'despesas',
  'conta',
  'outro',
] as const;
export const AppFeedbackThemeSchema = z.enum(APP_FEEDBACK_THEMES);
export type AppFeedbackTheme = z.infer<typeof AppFeedbackThemeSchema>;

export const AppFeedbackKindSchema = z.enum(['sugestao', 'elogio']);
export type AppFeedbackKind = z.infer<typeof AppFeedbackKindSchema>;

/** `registrada` = ainda sem PR; os outros dois são os marcos que o viajante vê. */
export const AppFeedbackStageSchema = z.enum(['registrada', 'in_development', 'published']);
export type AppFeedbackStage = z.infer<typeof AppFeedbackStageSchema>;

/** Um item do export: só campos estruturados, nunca o texto do viajante. */
export const AppFeedbackExportItemSchema = z
  .object({
    reportId: ProblemReportIdSchema,
    kind: AppFeedbackKindSchema,
    theme: AppFeedbackThemeSchema.nullable(),
    clientId: z.string().min(1).max(64).nullable(),
    stage: AppFeedbackStageSchema,
    recordedAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
  })
  .strict();
export type AppFeedbackExportItem = z.infer<typeof AppFeedbackExportItemSchema>;

/** Página do export; `next` = cursor da próxima (o `updatedAt` do último item), `null` no fim. */
export const AppFeedbackExportPageSchema = z.object({
  items: z.array(z.unknown()),
  next: z.iso.datetime().nullable(),
});
